import { GETCUSTOMERNAMEBYMOBILE, UPDATEBILL } from "../../utils/api";
import axios from "../../utils/axios";

export const UpdateBillCounterSell = async (params) => {
    const res = await axios.post(UPDATEBILL, params);
    return res;
  };
  

  export const getUserDetailByNumber=async(param,callback)=>{
      await axios.post(GETCUSTOMERNAMEBYMOBILE,param).then((res)=>{
        callback(res)
      }).catch((err)=>{
        console.log(err)
      })
  }